import { cn } from "../lib/cn";

/**
 * Pulse-animated placeholder block. Honours `prefers-reduced-motion`
 * via a CSS rule in index.css that suppresses the animation. The
 * animation is purely cosmetic; the static block still communicates
 * "content loading here".
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded bg-slate-200 dark:bg-slate-700", className)}
    />
  );
}

/**
 * Multi-row table skeleton. Useful for the list views where the data
 * shape is "N similar rows" — Vault, Nonconformities, AuditLog,
 * Members, Network, SupplierEvidence.
 */
export function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true" className="space-y-2">
      <span className="sr-only">Loading…</span>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="rounded-lg border border-slate-200 bg-white p-3 dark:border-slate-700 dark:bg-slate-800"
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-1/3" />
              <Skeleton className="h-3 w-2/3" />
            </div>
            <Skeleton className="h-6 w-16" />
          </div>
        </div>
      ))}
    </div>
  );
}
